import { TwoFAConfirm } from "@src/components/modules/auth/2fa-confirm";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const AuthTwoFactorConfirm = () => {
  return (
    <>
      <NoIndexHead />
      <TwoFAConfirm />
    </>
  );
};
export const Route = createFileRoute("/auth/two-factor/confirm")({
  component: AuthTwoFactorConfirm,
});
